let __HOST__;

switch (process.env.REACT_APP_STAGE) {
    case 'prod':
        __HOST__ = 'https://api.gameif.media/';
        break;
    case 'dev':
        __HOST__ = 'https://api-dev-web.gameif.media/';
        break;
    default:
        __HOST__ = 'http://localhost:9090/';
}

export const SERVER = __HOST__;
